import { i18n } from 'services';

export const isCheckboxRequired = (value: unknown) => {
  const message = i18n.t('formValidationErrors.isRequired');

  if (!value) {
    return message;
  }

  if (value instanceof Array) {
    if (value.length === 0) {
      return message;
    }
  }

  return undefined;
};
